import React from "react"

function CaptainShipIcon({ className, alt }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 80 48"
            className={className}
            aria-hidden={!alt}
            aria-label={alt || undefined}
        >
            <path d="M0 40 Q10 36 20 40 T40 40 T60 40 T80 40" fill="none" stroke="#4a90b5" strokeWidth="1.2" opacity="0.9" />
            <path d="M0 44 Q12 39 24 44 T48 44 T72 44 T80 44" fill="none" stroke="#5a9bb8" strokeWidth="1" opacity="0.7" />
            <path d="M20 37 L24 43 L56 43 L60 37 Z" fill="#a08060" stroke="#6b5344" strokeWidth="0.8" />
            <path d="M24 39 L28 43 L52 43 L56 39" fill="#8b6910" fillOpacity="0.5" />
            <rect x="38.5" y="14" width="3" height="28" rx="0.5" fill="#5c4a38" stroke="#4a3a2a" />
            <path d="M40 14 L62 36 L40 36 Z" fill="#c8e0ed" stroke="#6ba3c4" strokeWidth="0.6" />
            <path d="M40 18 L55 36" fill="none" stroke="#8bb8d0" strokeWidth="0.4" opacity="0.7" />
            <circle cx="28" cy="34" r="3" fill="#e8c49c" stroke="#c9a574" strokeWidth="0.4" />
            <path d="M26 32.5 L28 31 L30 32.5 L29.5 34 L26.5 34 Z" fill="#2c5282" />
            <path d="M25 37 L28 42 L31 37" fill="#2c5282" stroke="#1e3a4d" strokeWidth="0.3" />
            <ellipse cx="28" cy="39.5" rx="3.5" ry="2" fill="#2c5282" stroke="#1e3a4d" strokeWidth="0.3" />
            <circle cx="52" cy="38" r="4" fill="none" stroke="#5c4a38" strokeWidth="0.8" />
            <circle cx="52" cy="38" r="1.2" fill="#5c4a38" />
            <line x1="52" y1="34" x2="52" y2="42" stroke="#5c4a38" strokeWidth="0.6" />
            <line x1="48" y1="38" x2="56" y2="38" stroke="#5c4a38" strokeWidth="0.6" />
            <line x1="49.2" y1="34.2" x2="54.8" y2="41.8" stroke="#5c4a38" strokeWidth="0.5" />
            <line x1="49.2" y1="41.8" x2="54.8" y2="34.2" stroke="#5c4a38" strokeWidth="0.5" />
            <path d="M40 14 L44 16 L40 18 Z" fill="#b21a17" />
        </svg>
    )
}

export { CaptainShipIcon }
